import React, { useEffect, useState } from 'react'
import { Card, Col, FormControl, Row } from 'react-bootstrap'
import { Link, useOutletContext, useSearchParams } from 'react-router-dom'
import Error_500 from '../../../../error/error-500'
import {
  getEjipFundNameAPI,
  getEjipFundRoundNameAPI,
  getWelfareEjipsAPI
} from '../../../../../services/welfare-ejip'
import { FaAnglesRight } from 'react-icons/fa6'
import UseCheckStatusAdmin from '../../../../../hooks/use-check-status-admin'
import ButtonSummit from '../../employee-info/_btn-summit'
import LabelCustomSmall from '../../../../label-custom-small'
import AutocompleteCustom from '../../../../custom/autocomplete'
import fnUpdateArr from '../../../../../helper/fnUpdateArr'
import { BsExclamationCircle, BsPlusLg } from 'react-icons/bs'
import {
  createEjipMemberAPI,
  updateEjipMemberAPI
} from '../../../../../services/ejip'
import { TXTSUCCESS } from '../../../../../Constants'
import SwalCustom from '../../../../../alert/swal-custom'
import Error_false from '../../../../error/error-false'
import { fnDateEn } from '../../../../../helper/fnDateEn'
import CustomDatePicker from '../../../../custom/CustomDatePicker'

export default function EmpWelfareEJIP() {
  const { dataUser } = useOutletContext()
  let [searchParams, setSearchParams] = useSearchParams()

  const name = searchParams.get('name')

  const [optionRound, setOptionRound] = useState([])
  const [dataEJIP, setDataEJIP] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (dataUser) {
      fnGetData()
    }
  }, [dataUser])

  useEffect(() => {
    const getEjipFundName = async () => {
      const resp = await getEjipFundNameAPI()
      if (!resp) return
      if (resp.status) {
        setOptionRound(
          resp.result.map((d) => {
            return { label: d.fund_name, value: d.found_id }
          })
        )
      } else {
        setOptionRound([])
      }
    }
    getEjipFundName()
  }, [])

  const fnGetData = async () => {
    try {
      setIsLoading(true)
      const resp = await getWelfareEjipsAPI({
        code: dataUser.code,
        orgId: dataUser.orgId
      })
      setIsLoading(false)
      if (!resp) return
      if (resp.status) {
        setDataEJIP(
          resp.result.map((d) => ({
            ...d,
            id: d.member_id,
            fund: { label: d.fund_name, value: d.fund_id },
            round: { label: d.round, value: d.round_id },
            percent: d.percentage
          }))
        )
      } else {
        setDataEJIP([])
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const [isSubmit, setIsSubmit] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const statusAdmin = UseCheckStatusAdmin()
  const [isRead, setIsRead] = useState(true)

  const fnChangeData = (id, todo) => {
    const newData = fnUpdateArr(dataEJIP, id, todo)
    setDataEJIP(newData)
  }

  const [optionFundRound, setOptionFundRound] = useState([])

  const getEjipFundRoundName = async (id) => {
    const resp = await getEjipFundRoundNameAPI({ fundId: id })
    if (!resp) return
    if (resp.status) {
      setOptionFundRound(
        resp.result.map((d) => {
          return { value: d.round_id, label: d.round_name }
        })
      )
    } else {
      setOptionFundRound([])
    }
  }
  const [newEJIP, setNewEJIP] = useState({
    round: null,
    fund: null,
    percent: ''
  })

  const onSubmitCreate = async (body) => {
    try {
      setIsSubmitted(true)
      const resp = await createEjipMemberAPI(body)
      setIsSubmitted(false)
      if (!resp) return
      if (resp.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          fnGetData()
          setIsRead(true)
          setIsSubmit(false)
          setNewEJIP({
            percent: '',
            round: null,
            end_date: null,
            planType: null
          })
        })
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const FromCreateEJIP =
    statusAdmin?.status_id === 1 ? (
      <Row className="g-4 mb-5">
        <Col xl={12}>
          <div className="d-flex justify-content-between">
            <label className="fw-bold my-auto">เพิ่มสมาชิกกองทุน EJIP</label>
            <ButtonSummit
              textPimary={
                <>
                  <BsPlusLg className="me-2" /> Add Member
                </>
              }
              fnCancle={() => {
                setNewEJIP({
                  round: null,
                  fund: null,
                  percent: ''
                })
                setIsSubmit(false)
              }}
              isRead={isRead}
              setIsRead={setIsRead}
              isSave={isSubmitted}
              handleSubmit={() => {
                setIsSubmit(true)
                if (newEJIP.percent && newEJIP.round) {
                  const body = {
                    roundId: newEJIP.round.value,
                    member: [
                      {
                        code: dataUser.code,
                        orgId: dataUser.orgId,
                        per: newEJIP.percent,
                        username: dataUser.username
                      }
                    ]
                  }
                  onSubmitCreate(body)
                }
              }}
            />
          </div>
        </Col>

        {!isRead ? (
          <>
            <Col xl={12}>
              <LabelCustomSmall>สมาชิก</LabelCustomSmall>
              <div>{name}</div>
            </Col>
            <Col xl={4}>
              <LabelCustomSmall>Fund</LabelCustomSmall>

              <AutocompleteCustom
                disabled={isRead}
                isClearable={false}
                options={optionRound}
                value={newEJIP.fund}
                onChange={(e) => {
                  setNewEJIP((prev) => ({
                    ...prev,
                    fund: e,
                    round: null
                  }))
                  getEjipFundRoundName(e.value)
                }}
              />
              {!newEJIP.fund && isSubmit && (
                <label className="small text-danger fw-light">
                  <BsExclamationCircle /> Required field
                </label>
              )}
            </Col>
            <Col xl={4}>
              <LabelCustomSmall>Round</LabelCustomSmall>

              <AutocompleteCustom
                disabled={isRead}
                isClearable={true}
                options={optionFundRound}
                value={newEJIP.round}
                onChange={(e) => {
                  setNewEJIP((prev) => ({
                    ...prev,
                    round: e
                  }))
                }}
              />
              {!newEJIP.round && isSubmit && (
                <label className="small text-danger fw-light">
                  <BsExclamationCircle /> Required field
                </label>
              )}
            </Col>
            <Col xl={4}>
              <LabelCustomSmall>หักจากเงินเดือน (%)</LabelCustomSmall>

              <FormControl
                disabled={isRead}
                value={newEJIP.percent}
                onChange={(e) => {
                  setNewEJIP((prev) => ({
                    ...prev,
                    percent: e.target.value
                  }))
                }}
                type="number"
                min={0}
                maxLength={100}
              />
              {!newEJIP.percent && isSubmit && (
                <label className="small text-danger fw-light">
                  <BsExclamationCircle /> Required field
                </label>
              )}
            </Col>
          </>
        ) : (
          <>
            <p className="text-center">- ยังไม่เป็นสมาชิกกองทุน EJIP -</p>
          </>
        )}
      </Row>
    ) : (
      <p className="text-center">- ไม่อยู่ในสมาชิกกองทุน EJIP -</p>
    )

  const onSubmitEdit = async (body) => {
    try {
      setIsSubmitted(true)
      const resp = await updateEjipMemberAPI(body)
      setIsSubmitted(false)

      if (!resp) return
      if (resp.status) {
        SwalCustom({
          title: 'Success!',
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          fnGetData()
          setIsRead(true)
        })
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  return (
    <>
      <Card.Body>
        <h5>
          <Link
            to={-1}
            className={`my-auto text-reset text-decoration-none  pointer-event`}
          >
            <span className="text-primary">
              การลงทุน <FaAnglesRight />
            </span>
            <label className="small fw-light ms-2">EJIP</label>
          </Link>
        </h5>

        <div className="mb-4" />

        {isLoading ? (
          <Row className="g-4 mb-5">
            <Col xl={12}>
              <p className="placeholder col-12"></p>
            </Col>
            <Col xl={4}>
              <p className="placeholder h3 col-12"></p>
            </Col>
            <Col xl={4}>
              <p className="placeholder h3 col-12"></p>
            </Col>
            <Col xl={4}>
              <p className="placeholder h3 col-12"></p>
            </Col>
            <Col xl={4}>
              <p className="placeholder h3 col-12"></p>
            </Col>
          </Row>
        ) : (
          <>
            {dataEJIP.length > 0 &&
              dataEJIP.length ===
                dataEJIP.filter((item) => item.is_active === 0).length && (
                <>{FromCreateEJIP}</>
              )}

            {dataEJIP.length > 0 ? (
              dataEJIP.map((d, i) =>
                d.is_active === 1 ? (
                  <Row className="g-4 mb-5">
                    <Col xl={12}>
                      <div className="d-flex justify-content-between">
                        <label className="fw-bold my-auto">
                          Entry Date:{' '}
                          {d.entry_date
                            ? fnDateEn(d.entry_date).format('DD/MM/YYYY')
                            : '-'}
                        </label>
                        {statusAdmin?.status_id === 1 && (
                          <ButtonSummit
                            isRead={isRead}
                            setIsRead={setIsRead}
                            isSave={isSubmitted}
                            handleSubmit={() => {
                              const body = {
                                memberId: d.member_id,
                                per: d.percent,
                                closeDate: d.closeDate
                              }
                              onSubmitEdit(body)
                            }}
                          />
                        )}
                      </div>
                    </Col>
                    <Col xl={4}>
                      <LabelCustomSmall>Fund</LabelCustomSmall>

                      <AutocompleteCustom
                        disabled={true}
                        isClearable={true}
                        options={optionRound}
                        value={d.fund}
                        onChange={(e) => {
                          fnChangeData(d.id, {
                            fund: e
                          })
                          getEjipFundRoundName(e.value)
                        }}
                      />
                      {!d.fund && isSubmit && (
                        <label className="small text-danger fw-light">
                          <BsExclamationCircle /> Required field
                        </label>
                      )}
                    </Col>
                    <Col xl={4}>
                      <LabelCustomSmall>Round</LabelCustomSmall>

                      <AutocompleteCustom
                        disabled={true}
                        isClearable={true}
                        options={optionFundRound}
                        value={d.round}
                        onChange={(e) => {
                          fnChangeData(d.id, {
                            round: e
                          })
                        }}
                      />
                      {!d.round && isSubmit && (
                        <label className="small text-danger fw-light">
                          <BsExclamationCircle /> Required field
                        </label>
                      )}
                    </Col>
                    <Col xl={4}>
                      <LabelCustomSmall>หักจากเงินเดือน (%)</LabelCustomSmall>

                      <FormControl
                        disabled={isRead}
                        value={d.percent}
                        onChange={(e) => {
                          fnChangeData(d.id, {
                            percent: e.target.value
                          })
                        }}
                        type="number"
                        min={0}
                        maxLength={100}
                      />
                      {!d.percent && isSubmit && (
                        <label className="small text-danger fw-light">
                          <BsExclamationCircle /> Required field
                        </label>
                      )}
                    </Col>
                    <Col xl={4}>
                      <LabelCustomSmall>วันที่ออกจากกองทุน</LabelCustomSmall>
                      <CustomDatePicker
                        showYearDropdown
                        showMonthDropdown
                        disabled={isRead}
                        isClearable={true}
                        onChange={(e) => {
                          fnChangeData(d.id, {
                            closeDate: e
                              ? fnDateEn(e).format('YYYY-MM-DD')
                              : null
                          })
                        }}
                        value={d.closeDate}
                      />
                    </Col>
                  </Row>
                ) : (
                  <Row className="g-4 mb-5">
                    <Col xl={12}>
                      <label className="fw-bold my-auto">
                        Entry Date:{' '}
                        {d.entry_date
                          ? fnDateEn(d.entry_date).format('DD/MM/YYYY')
                          : '-'}
                      </label>
                    </Col>
                    <Col xl={4}>
                      <LabelCustomSmall>Fund</LabelCustomSmall>
                      <div>{d.fund?.label ?? '-'}</div>
                    </Col>
                    <Col xl={4}>
                      <LabelCustomSmall>Round</LabelCustomSmall>
                      <div>{d.round?.label ?? '-'}</div>
                    </Col>
                    <Col xl={4}>
                      <LabelCustomSmall>หักจากเงินเดือน (%)</LabelCustomSmall>
                      <div>{d.percentage}%</div>
                    </Col>
                    <Col xl={4}>
                      <LabelCustomSmall>วันที่ออกจากกองทุน</LabelCustomSmall>
                      <div>
                        {d.resignation_date
                          ? fnDateEn(d.resignation_date).format('DD/MM/YYYY')
                          : '-'}
                      </div>
                    </Col>
                  </Row>
                )
              )
            ) : (
              <>{FromCreateEJIP}</>
            )}

            {statusAdmin?.status_id === 2 && (
              <div className="text-center">
                <label className="text-muted">
                  <b>Organization Right:</b> Read Only
                </label>
              </div>
            )}
          </>
        )}
      </Card.Body>
    </>
  )
}
